module.exports = __webpack_public_path__ + "img/icon_map_xiaofangshuan_gaojing_dianji.b5d99c20.svg";